import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PagePreview } from '../mockups/PagePreview';
import { OptimizedImage } from '../OptimizedImage';
import { images, solutionPoints } from '../../data/content';
export function Solution() {
  return <section className="bg-brand-50 py-12 lg:py-20" aria-labelledby="solution-title" data-id="element-443" data-mp="8ytd7m5ke0a">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 lg:grid-cols-[1.05fr_1fr] lg:gap-14" data-id="element-444" data-mp="3rcdoot92plsm">
        <div data-id="element-445" data-mp="96iveiruaeby">
          <h2 id="solution-title" className="font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-446" data-mp="96966xemcb7b">
             <span className="text-brand-600" data-id="element-447" data-mp="iyoo5upx0zs7">REACTIVA TU CUERPO™</span>
          </h2>
          
          <p className="mt-4 text-sm font-semibold text-ink" data-id="element-448" data-mp="dyiqnxwysj27">Todo organizado en un solo lugar para ayudarte a:</p>
          <ul className="mt-2 grid gap-x-4 gap-y-1.5 sm:grid-cols-2" data-id="element-449" data-mp="rzv524wh8clz">
            {solutionPoints.map(p => <li key={p} className="flex items-start gap-2 text-sm leading-snug text-ink" data-id="element-450" data-mp="ny18o8tbdurm">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-600" strokeWidth={3} aria-hidden="true" data-id="element-451" data-mp="1vv8c9cyrp0ug" />
                {p}
              </li>)}
          </ul>
          <blockquote className="mt-6 rounded-2xl bg-brand-600 p-5 text-white" data-id="element-452" data-mp="1zxv6fkiwuxut">
            <p className="font-display text-sm font-bold uppercase leading-snug tracking-wide text-brand-100" data-id="element-453" data-mp="24x7v8atcef01">
              No se trata solamente de tener más ejercicios.
            </p>
            <p className="mt-1.5 font-display text-lg font-extrabold leading-snug sm:text-xl" data-id="element-454" data-mp="2et2hrh0osu83">
              Se trata de tener más herramientas para saber qué hacer, cómo organizarlo y cómo aplicarlo.
            </p>
          </blockquote>
        </div>

        <div className="relative hidden pb-10 pr-10 lg:block" data-id="element-455" data-mp="2sl8wcyo6yt5f">
          <OptimizedImage src={images.planning} alt="Instructora planificando una sesión para adultos mayores en su tablet" width={1184} height={888} className="aspect-[4/3] h-auto w-full rounded-[28px] bg-brand-100 object-cover" data-id="element-456" data-mp="2smtvl1lgb09m" />
          <PagePreview variant="planner" title="Sesión de 45 min" className="absolute -bottom-2 right-0 w-[30%] rotate-[5deg]" data-id="element-457" data-mp="2cu86iaz3xqd7" />
          <PagePreview variant="exercise" title="Movilidad" className="absolute -bottom-6 right-[26%] w-[28%] -rotate-[4deg]" data-id="element-458" data-mp="27wzme4uefc9b" />
        </div>
      </div>
    </section>;
}